locations = {
	notifications: {
		cardSavingError: "Block saving error",
		cardCreatingError: "Block saving error",
		cardRemoving: "Block has been deleted",
		cardRemovingError: "Block deleting error",
		cardsSortintgError: "Sorting error",
		cardUnTrashError: "Unfortunately, card cannot be restored",

		imageUploadingError: "Image uploading error",
		imageRemovingError: "Image deleting error",
		imageLoadingError: "Image could not be loaded",

		wrongFileType: "Wrong file type",

		copyToClipboard: "URL has been copied to the clipboard",
		optionsSaving: "Object options have been applied",
		optionsSavingError: "Object options couldn't be applied",

		templatesRetrievingError: "Couldn't retrieve templates",

		boardRetrievingError: "Couldn't retrieve board",
		boardSavingError: "Object couldn't be saved",
		boardRemoving: "Object has been removed",
		boardRemovingError: "Object removing error",
		boardWarning: "Object should contain at least one card",
		boardCloning: "Object has been added to the Dashboard",
		boardClonError: "Template couldn't be applied",
		boardsClonError: "Templates couldn't be applied",
		boardUnTrashError: "Unfortunately, board cannot be restored",

		getCardError: "Retrieving card error",

		sharingSuccess: "Posting completed",
		sharingError: "Error while posting"
	}
}